import {
  FileSearchOutlined,
  UnorderedListOutlined,
  AreaChartOutlined,
  FileAddOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { ReactComponent as Timecheck } from "../asset/svg/time_check_blue.svg";
import { ReactComponent as Cashup } from "../asset/svg/cashup.svg";
import { ReactComponent as IncomeByStaff } from "../asset/svg/income_by_staff.svg";
import { ReactComponent as PayoutReport } from "../asset/svg/payout_report.svg";
import { ReactComponent as PayoutList } from "../asset/svg/payout_list.svg";
import { ReactComponent as PayrateBonus } from "../asset/svg/payrate_bonus.svg";
import { ReactComponent as PayoutSetting } from "../asset/svg/payout_setting.svg";

const size = 34;

export const TABS_ACTIVE = [
  { key: "1", route: "shop", tab: "Shop" },
  { key: "2", route: "payment", tab: "Payment" },
  { key: "3", route: "staff", tab: "Staff" },
  { key: "4", route: "access", tab: "Access" },
  { key: "5", route: "voucher", tab: "Voucher" },
  { key: "6", route: "services", tab: "Services" },
];

export const TERMS_OPTIONS = [
  { label: "Default", value: "Default" },
  { label: "None", value: "None" },
  { label: "Custom", value: "Custom" },
];

export const DEFAULT_TERM =
  "This voucher is valid until the expiry date specified and cannot be redeemed or replaced after this date. {{Shop name}} is not responsible for lost / stolen vouchers, and is not responsible for replacing a voucher that has been lost / stolen. This voucher is non-refundable and cannot be exchanged for cash. This voucher is not valid with any other offer and / or special at {{Shop name}} ({{Shop Location}}). This voucher must be used by one person in one visit";

export const VOUCHER_SUB = [
  { label: "Details", value: "detail", icon: <UnorderedListOutlined /> },
  { label: "Issue", value: "search", icon: <FileAddOutlined /> },
  { label: "Redeem", value: "report", icon: <FileDoneOutlined /> },
];

export const VOUCHER_STATUS = [
  { label: "All", value: "all" },
  { label: "Online", value: "website" },
  { label: "Give away", value: "admin" },
];

export const LEVELS = [
  { name: "Trainee", color: "#fd9644" },
  { name: "Level 1", color: "#eb3b5a" },
  { name: "Level 2", color: "#20bf6b" },
  { name: "Level 3", color: "#4b7bec" },
  { name: "Level 4", color: "#a55eea" },
];

export const REQUEST_SICK = "Sick leave";
export const REQUEST_PLACE = "Change Workplace";
export const REQUEST_TIME = "Change Worktime";
export const REQUEST_OFF = "Request Day Off";
export const REQUEST_SENT = "Sent";
export const REQUEST_ALL = "All";
export const REQUEST_REJECTED = "Rejected";
export const REQUEST_ACCEPTED = "Accepted";
export const REQUEST_OPTIONS = [
  { value: "All", label: "All" },
  { value: "Sent", label: "Sent" },
  { value: "Accepted", label: "Accepted" },
  { value: "Rejected", label: "Rejected" },
];

export const REPORT_MENU = [
  {
    key: 1,
    title: "Time Tracking",
    route: "time-tracking",
    icon: <Timecheck width={50} height={50} />,
  },
  {
    key: 2,
    title: "Cashup Report",
    route: "cashup/list",
    icon: <Cashup width={50} height={50} />,
  },
  {
    key: 3,
    title: "Income by staff",
    route: "cashup/income-by-staff",
    icon: <IncomeByStaff width={50} height={50} />,
  },
  {
    key: 4,
    title: "Payout Report",
    route: "payout-report",
    icon: <PayoutReport width={50} height={50} />,
  },
];

export const PAYOUT_MENU = [
  {
    key: 1,
    title: "Payout List",
    route: "list",
    icon: <PayoutList width={50} height={50} />,
  },
  {
    key: 2,
    title: "Payrate & Bonus",
    route: "payrate-bonus",
    icon: <PayrateBonus width={50} height={50} />,
  },
  {
    key: 3,
    title: "Payout Configs",
    route: "setting",
    icon: <PayoutSetting width={50} height={50} />,
  },
];

export const STATUS_CASHUP = [
  {
    label: "Confirmed",
    value: "confirmed",
  },
  {
    label: "Unconfirmed",
    value: "unconfirmed",
  },
];
